var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "progress-circular-wrapper" },
    [
      _c(
        "v-progress-circular",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.time > 0,
              expression: "time > 0",
            },
          ],
          staticClass: "rounded-circle",
          class: _vm.contdownClasses,
          attrs: { width: 4, rotate: -90 },
          model: {
            value: _vm.timeValue,
            callback: function ($$v) {
              _vm.timeValue = $$v
            },
            expression: "timeValue",
          },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.timeLeft >= 0 ? _vm.timeLeft : 0) + "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }